export const FormState = {
    UNINITIALIZED: "UNINITIALIZED",
    INITIALIZED: "INITIALIZED",
    PENDING_CONFIRMATION: "PENDING_CONFIRMATION",
    CONFIRMED: "CONFIRMED",
    ERROR: "ERROR",
  };
  